import styles from './HeroSection.module.css';
import anim from '@/styles/animations.module.css';

interface HeroSectionProps {
  title: string;
  subtitle?: string;
  variant?: 'home' | 'compact' | 'desktop';
  className?: string;
}

export function HeroSection({ title, subtitle, variant = 'home', className }: HeroSectionProps) {
  const root = [
    styles.hero,
    variant === 'compact' ? styles.heroCompact : '',
    variant === 'desktop' ? styles.heroDesktop : '',
    anim.fadeIn,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const titleCls = [styles.title, variant === 'compact' ? styles.titleSm : ''].filter(Boolean).join(' ');

  const subCls = [styles.sub, variant === 'compact' ? styles.subLeft : ''].filter(Boolean).join(' ');

  return (
    <header className={root}>
      <h1 className={titleCls}>{title}</h1>
      {subtitle ? <p className={subCls}>{subtitle}</p> : null}
    </header>
  );
}
